export default {"src":"/_next/static/media/tui-cruises.aa1065ef.svg","height":54,"width":220,"blurWidth":0,"blurHeight":0};